import { useMemo, useState } from 'react';
import { useReadOnlyWarning } from 'hooks';

import {
  appsIcon,
  assetsIcon,
  bridgeIcon,
  contactsIcon,
  dashboardIcon,
  ownersIcon,
  permissionsIcon,
  rbridgeIcon,
  settingsIcon,
  stackingIcon,
  streamingIcon,
  txsIcon,
} from './images';

export const useMenuList = (safeId: string | undefined, safeAddress: string | undefined) => {
  const isReadOnlyMode = Boolean(useReadOnlyWarning());

  const menuOptions: {
    key: string;
    title: string;
    icon: string;
    path?: string;
    external?: boolean;
    disabled?: boolean;
    pro?: boolean;
    soon?: boolean;
  }[] = [
    // {
    //   key: 'home',
    //   title: 'Home',
    //   icon: homeIcon,
    //   path: '',
    // },
    {
      key: 'dashboard',
      title: 'Dashboard',
      icon: dashboardIcon,
      path: `/vault/${safeAddress}/dashboard`,
    },
    {
      key: 'assets',
      title: 'Assets',
      icon: assetsIcon,
      path: `/vault/${safeAddress}/assets`,
    },
    {
      key: 'transactions',
      title: 'Transactions',
      icon: txsIcon,
      path: `/vault/${safeAddress}/activity`,
    },
    {
      key: 'stacking',
      title: 'Stacking',
      icon: stackingIcon,
      // path: '',
      path: `/vault/${safeAddress}/stacking`,
      // external: true,
    },
    {
      key: 'bridge',
      title: 'sBTC Bridge',
      icon: bridgeIcon,
      // path: `https://app.stacks.co/`,
      path: `/vault/${safeAddress}/sbtc`,
      // external: true,
    },
    {
      key: 'bridge_runes',
      title: 'Runes Bridge',
      icon: rbridgeIcon,
      path: `https://app.pontis.io/`,
      external: true,
    },
    {
      key: 'streaming',
      title: 'Payroll Management',
      icon: streamingIcon,
      path: `/vault/${safeAddress}/streaming`,
      soon: true,
    },
    {
      key: 'permissions',
      title: 'Permissions',
      icon: permissionsIcon,
      path: `/vault/${safeAddress}/permissions`,
    },
    {
      key: 'contacts',
      title: 'Contacts',
      icon: contactsIcon,
      disabled: isReadOnlyMode,
      path: `/vault/${safeAddress}/contacts`,
    },
    {
      key: 'apps',
      title: 'Apps',
      icon: appsIcon,
      disabled: isReadOnlyMode,
      path: `/vault/${safeAddress}/apps`,
      pro: false,
    },
    // {
    //   key: 'pro',
    //   title: 'Asigna Pro',
    //   icon: proIcon,
    //   path: `/vault/${safeAddress}/pro`,
    // },
    {
      key: 'settings',
      title: 'Settings',
      icon: settingsIcon,
      path: `/vault/${safeAddress}/settings`,
    },
  ];

  const menuInviteOptions: {
    key: string;
    title: string;
    icon: string;
    path: string;
    external?: boolean;
    disabled?: boolean;
    soon?: boolean;
  }[] = [
    {
      key: 'owners.pending',
      title: 'Owners',
      icon: ownersIcon,
      path: `/invite/${safeId}`,
    },
  ];
  const [selectedTab, setSelectedTab] = useState(menuOptions[0].key);

  return useMemo(
    () => ({ selectedTab, setSelectedTab, menuOptions, menuInviteOptions }),
    [selectedTab, safeId, menuInviteOptions]
  );
};
